import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import "./Loading.scss";

interface Props {
  cancel?: () => void;
}

export const Loading = (props: Props, ref: any) => {
  const [showCancel, setShowCancel] = React.useState(false);

  const handleClickLoading = () => {
    if (props.cancel) {
      props.cancel();
    }
  };

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setShowCancel(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="loading-container">
      <div className="loading-box">
        <Box sx={{ height: 40 }}>
          <CircularProgress />
        </Box>
        {showCancel && (
          <Button onClick={handleClickLoading} sx={{ mt: 0.625 }}>
            Stop loading
          </Button>
        )}
      </div>
    </div>
  );
};
